import { axios } from '@Root/API'

export const getAll = (id, params) => {
	return axios.get(`cost-centre-modules/${id}`, { params })
}
